import '@d3fc/d3fc-element';
import { seriesSvgPoint } from '@d3fc/d3fc-series';
import { OrderFill } from 'widgets/fillsGraph/fillsGraphData';
import { Selection, BaseType } from 'd3-selection';
import { SymbolTileDataTimeSeriesItem } from 'widgets/symbolTile/components/symbolTileData';
export const blobSize = 10;

const pointSymbol = {
    draw: function (context: CanvasRenderingContext2D, size: number) {
        context.lineWidth = 1;
        context.arc(0, 0, size / 2, 0, 2 * Math.PI);
        context.closePath();
    },
};

export const highPricePoint = seriesSvgPoint()
    .crossValue((x: SymbolTileDataTimeSeriesItem) => x.time)
    .mainValue((x: SymbolTileDataTimeSeriesItem) => x.high)
    .size(blobSize)
    .type(pointSymbol)
    .decorate((s: Selection<BaseType, OrderFill, null, unknown>) => {
        s.classed('high-price', true);
    });

export const lowPricePoint = seriesSvgPoint()
    .crossValue((x: SymbolTileDataTimeSeriesItem) => x.time)
    .mainValue((x: SymbolTileDataTimeSeriesItem) => x.low)
    .size(blobSize)
    .type(pointSymbol)
    .decorate((s: Selection<BaseType, OrderFill, null, unknown>) => {
        s.classed('low-price', true);
    });

export const lastPricePoint = seriesSvgPoint()
    .crossValue((x: SymbolTileDataTimeSeriesItem) => x.time)
    .mainValue((x: SymbolTileDataTimeSeriesItem) => x.last)
    .size(blobSize)
    .type(pointSymbol)
    .decorate((s: Selection<BaseType, OrderFill, null, unknown>) => {
        s.classed('last-price', true);
    });
